import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) { navigate("/", { replace: true }); return; }

    (async () => {
      try {
        const r = await api.post("/auth/google/session", { session_id: sid });
        setUser(r.data.user);
        toast.success(`Welcome, ${r.data.user.name?.split(" ")[0] || ""}!`);
        // Strip hash and route
        window.history.replaceState(null, "", window.location.pathname);
        navigate(r.data.user.role === "owner" ? "/dashboard" : "/", { replace: true });
      } catch (e) {
        toast.error("Google login failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="grid h-screen place-items-center text-slate-500">
      <div className="flex items-center gap-3">
        <Loader2 className="h-5 w-5 animate-spin text-cyan-600" />
        <span>Signing you in…</span>
      </div>
    </div>
  );
}
